﻿'use strict';

angular.module('ntmApp')
  .directive('awesomeIcon', ['$timeout', 'Constants', function ($timeout, Constants) {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/awesomeIcon.html',
          scope: {
              ngModel: '=',
              hideText: '='
          },
          link: function (scope) {

              function buildicon() {
                  scope.showIcon = false;
                  if (scope.ngModel && scope.ngModel !== '') {
                      var icon = scope.ngModel.split(';');
                      scope.icon = {};

                      scope.icon.style = '{0} fa-{1} fa-{2}'
                          .format(
                            icon[2] && Constants.ActivityIcons.iconStyles[icon[2]] ? Constants.ActivityIcons.iconStyles[icon[2]].className : Constants.ActivityIcons.iconStyles[Constants.ActivityIcons.iconStyles.solid.name].className,
                            icon[0],
                            icon.length === 4 ? Constants.ActivityIcons.iconAnimations[icon[3]].className : Constants.ActivityIcons.iconAnimations.none.className
                          );
                      scope.icon.color = icon[1] ? icon[1] : '#757575';
                  }

                  $timeout(function () { scope.showIcon = true; }, 5);
              }

              buildicon();

              scope.$watch('ngModel', function (newVal, oldVal) {
                  if (newVal !== oldVal) {
                      buildicon();
                  }
              });
          }
      };
  }]);